// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { getAllFeatureDetailsForSelectedYearInReleaseNotes } from 'src/app/api/remote-api/.portal.generated/fn/feature-details/get-all-feature-details-for-selected-year-in-release-notes';
import { getYearImages } from 'src/app/api/remote-api/.portal.generated/fn/feature-details/get-year-images';
import { getYears } from 'src/app/api/remote-api/.portal.generated/fn/feature-details/get-years';

import { MapApiService } from '../../shared/services/map-api.service';

@Injectable({
  providedIn: 'root',
})
export class ReleaseNotesService {
  constructor(private mapApiService: MapApiService) {}

  public featureListForSelectedYear = this.mapApiService.mapEndpoint(
    getAllFeatureDetailsForSelectedYearInReleaseNotes
  );

  public releaseYears = this.mapApiService.mapEndpoint(getYears);

  public yearImages = this.mapApiService.mapEndpoint(getYearImages);
}
